import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  srOnly: {
    position: 'absolute',
    width: 1,
    height: 1,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    whiteSpace: 'nowrap'
  },
  statusTag: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  // explicit text color: the policy Incidents table is dark and would otherwise lend the pill its light text
  // doubled selector so these win over the core Tag's own class whatever order the sheets load in
  tag: {
    '&&': {
      color: theme.colorPalette.green_100,
      height: 'auto',
      minHeight: 24,
      lineHeight: '16px',
      whiteSpace: 'nowrap',
      borderRadius: theme.spacing(3)
    }
  },
  notCountedTag: {
    '&&': {
      backgroundColor: theme.colorPalette.beige_75
    }
  },
  // the dialog follows the layout of the offer's claim dispute modals
  paper: {
    width: 580,
    maxWidth: 580,
    backgroundColor: theme.colorPalette.beige_25
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(8)
  },
  textGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(4)
  },
  backButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    marginLeft: -theme.spacing(2),
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    color: theme.colorPalette.orange_50,
    font: 'inherit',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '20px'
  },
  backIcon: {
    width: 24,
    height: 24
  },
  body: {
    color: theme.colorPalette.green_80,
    fontSize: 16,
    lineHeight: '24px',
    margin: 0
  },
  records: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3)
  },
  record: {
    display: 'flex',
    gap: theme.spacing(2)
  },
  recordDivider: {
    width: 2,
    alignSelf: 'stretch',
    flexShrink: 0,
    backgroundColor: theme.colorPalette.beige_75
  },
  recordInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  recordName: {
    fontSize: 16,
    lineHeight: '24px',
    color: theme.colorPalette.green_80
  },
  recordMeta: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    fontSize: 12,
    lineHeight: '16px',
    color: theme.colorPalette.green_75
  },
  fieldLabel: {
    fontSize: 10,
    fontWeight: 600,
    lineHeight: '12px',
    textTransform: 'uppercase',
    color: theme.colorPalette.green_75,
    margin: 0
  },
  alsoSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  alsoBody: {
    fontSize: 14,
    lineHeight: '20px',
    color: theme.colorPalette.green_80,
    margin: theme.spacing(2, 0)
  },
  callout: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    padding: theme.spacing(4),
    borderRadius: theme.sizes.innerCorners,
    backgroundColor: theme.colorPalette.beige_40
  },
  calloutIcon: {
    width: 16,
    height: 16,
    flexShrink: 0,
    marginTop: 2
  },
  calloutText: {
    color: theme.colorPalette.green_100,
    fontSize: 14,
    lineHeight: '20px',
    margin: 0
  },
  error: {
    color: theme.colors.error,
    fontSize: 14,
    margin: 0
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2)
  }
}));
